<template>
  <checkbox-dropdown :checked-values="value"
                     :options="dayOptions"
                     :is-no-value-allowed="true"
                     grid-cols="2"
                     class="pt-5"
                     :hide-footer="true"
                     @change="onToggleCheckbox($event)"
  />
</template>

<script>
import conditionUtils from '@/utils/condition.utils'
import CheckboxDropdown from '@/components/common/CheckboxDropdown'
import { CONDITION_CASES } from '@/store/constants'

export default {
  name: 'ConditionCaseDay',

  components: { CheckboxDropdown },

  props: {
    value: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      dayOptions: [
        { name: 'Monday', id: 'monday' },
        { name: 'Friday', id: 'friday' },
        { name: 'Tuesday', id: 'tuesday' },
        { name: 'Saturday', id: 'saturday' },
        { name: 'Wednesday', id: 'wednesday' },
        { name: 'Sunday', id: 'sunday' },
        { name: 'Thursday', id: 'thursday' }
      ]
    }
  },

  methods: {
    onToggleCheckbox(selectedDays) {
      const sortedDaysMap = { monday: 0, tuesday: 1, wednesday: 2, thursday: 3, friday: 4, saturday: 5, sunday: 6 }
      const sortedDays = selectedDays.sort((a, b) => sortedDaysMap[a] - sortedDaysMap[b])
      this.$emit('input', conditionUtils.createConditionJson(CONDITION_CASES.DAY, sortedDays))
    }
  }
}
</script>
